module.exports = __webpack_public_path__ + "img/uk-pneumonia-male.04cab81a.png";